/** @jsx jsx */
import { jsx } from '@emotion/react'
import React from 'react'
import { createRoot } from 'react-dom/client'
import { Tile, } from '../components/TeaserTile'

export class TeaserTile extends HTMLElement {
  connectedCallback () {
    const mountPoint = document.createElement('div')
    this.attachShadow({ mode: 'open' }).appendChild(mountPoint)
    mountPoint.style.display = 'inline-block';
    mountPoint.style.margin = '1em';

    const title = this.getAttribute('title') ?? "";
    const image = this.getAttribute('image') ?? "";
    const href = this.getAttribute('href') ?? "";
    for(let i=0; i<this.children.length; i++) {
      const child = this.children[i];
      child.setAttribute('slot', `default`);
    }
    createRoot(mountPoint).render(<Tile title={title} image={image} url={href} styleRoot={mountPoint} />);
  }
}
customElements.define('teaser-tile', TeaserTile)
